import React from 'react';
import { inject,observer } from 'mobx-react';
import * as mobx from 'mobx';
import { getAntd,getEcCom,getLabel } from '../../../util/convert';
import Content from './Content';

@inject('printLogStore')
@observer
export default class Main extends React.Component{
    render(){
        const { WeaDialog } = getEcCom();
        const { visible } = this.props;
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@w5x0da`}
                visible={visible}
                loadCss={true}
                initLoadCss={true}
                title={getLabel(21533,'打印日志')}
                icon="icon-coms-workflow"
                iconBgcolor='#0079DE'
                maskClosable={false}
                onCancel={this.doCancel}
                style={{width:"1000px", height:"520px"}}
                layout={jQuery('.wf-req')[0]}
            >
                <Content ecId={`${this && this.props && this.props.ecId || ''}_Content@limsl7`} {...this.props} />
            </WeaDialog>
        )
    }
    doCancel = () => {
        const { printLogStore } = this.props;
        printLogStore.closeEvent();
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/print-log/index.js